import styled from 'styled-components';

export default styled.div`
  && {
    .detail-medical {
      background-color: #ecffb8;
      height: 66px;
      padding: 10px 65px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .btn-edit {
        width: 112px;
        height: 48px;
        background: #ff8a00;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        border: none;
        color: white;
      }
    }
    .section {
      padding: 55px 65px;
      .detail {
        box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        .info {
          margin: 40px 25px 47px 25px;
          .mb-15 {
            margin-bottom: 15px;
            padding-bottom: 15px;
            border-bottom: 1px solid #dddddd;
          }
          .not-border-bottom {
            margin-bottom: 0;
            padding-bottom: 0;
            border-bottom: unset;
          }
          .label {
            margin-top: 25px;
            font-weight: bold;
            font-size: 12px;
          }
          .textarea {
            padding: 10px;
            background: #f4f4f4;
            border-radius: 5px;
            height: 100px;
            overflow-y: auto;
            white-space: pre;
          }
          .mb-10 {
            margin-bottom: 10px;
          }
          .mb-15:last-child {
            border-bottom: none;
            padding-bottom: 47px;
          }
          .bbt {
            border-bottom: 1px solid #dddddd;
          }
          .flex-align {
            dislplay: flex;
            align-items: center;
          }
        }
      }
    }
  }
`;
